export default __webpack_public_path__ + "static/media/legal-docs.6fc0f88a.svg";